module.exports = __webpack_public_path__ + "img/profile.3b14cb4a.svg";